import {isLocked409} from 'data/errors';

const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

/**
 * Applies the Base (when set) and then each Patch, in the given order, one at a time: the project is one locked
 * operation per apply on the API, so two applies in flight only collide. A 409 `project_locked` is retried once after
 * `retryDelayMs`. The first failure stops the sequence: it is `failed` and the wizards after it are `notAttempted`.
 * @param {{base: ?number, patches: number[], apply: function(number): Promise, sleep: ?function(number): Promise, retryDelayMs: ?number}} options
 * @returns {Promise<{applied: number[], failed: ?{id: number, error: *}, notAttempted: number[], responses: object[]}>}
 */
export const applySequence = async ({base, patches, apply, sleep = wait, retryDelayMs = 1000}) => {
    const order = base === null || base === undefined ? [...patches] : [base, ...patches];
    const applied = [];
    const responses = [];

    const applyOnce = async (id) => {
        try {
            return await apply(id);
        } catch (error) {
            if (!isLocked409(error)) {
                throw error;
            }
            await sleep(retryDelayMs);
            return apply(id);
        }
    };

    for (let index = 0; index < order.length; index++) {
        const id = order[index];
        try {
            responses.push(await applyOnce(id));
            applied.push(id);
        } catch (error) {
            return {applied, failed: {id, error}, notAttempted: order.slice(index + 1), responses};
        }
    }
    return {applied, failed: null, notAttempted: [], responses};
};
